import React, { useState,useEffect } from 'react'
import './css/CreatePassword.css'
import { useLocation } from 'react-router-dom'

function CreatePassword() {

    const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;

    const location = useLocation(null)
    const [email,setEmail] = useState('')
    const [token,setToken] = useState('')
    const [tokenTimeout,setTokenTimeout] = useState('')
    
    useEffect(() => {
        if (location.search) {
            const searchParams = new URLSearchParams(location.search);
            const clientEmail = searchParams.get('email');
            const clientToken = searchParams.get('token');

            setEmail(clientEmail);
            setToken(clientToken);
            setTokenTimeout(clientToken)
        }
    }, []);

    const [password,setPassword] = useState('')

    const handlePassword = (e,fieldName) => {
        const value = e.target.value
        setPassword((prev) => ({
            ...prev,
            [fieldName] : value
        }))
    }

    const handleChangePassword = async () => {
        if (tokenTimeout === token) {
            try{
                const response = await fetch(
                    `${apiBaseUrl}/changePassword?email=${email}&password=${password.password}`
                );
            } catch (error) {
                // //(error);
            }
        } else {
            alert("Invalid")
        }
    }

    const generateOTP = () => {
        const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
        let otp = '';
        for (let i = 0; i < 10; i++) {
            const randomIndex = Math.floor(Math.random() * characters.length);
            otp += characters[randomIndex];
        }
        return otp;
    };

    const [countdown, setCountdown] = useState(30);
    const [linkExpired, setLinkExpired] = useState(false);

    useEffect(() => {
        if (tokenTimeout === token) {
            const countdownInterval = setInterval(() => {
                setCountdown((prevCountdown) => {
                    if (prevCountdown <= 1) {
                        clearInterval(countdownInterval);
                        setTokenTimeout(generateOTP())
                        
                        return 0;
                    }
                    return prevCountdown - 1;
                });
            }, 1000);
    
            return () => clearInterval(countdownInterval); 
        } else {
            setLinkExpired(true)
        }
    }, [tokenTimeout]);

  return (
    <div className='CreatePassword_Container'>
        {linkExpired ? (
            <div>
                Error
            </div>
        ) : (
            <div className='CreatePassword_ContainerDiv'>
                <div className='CreatePassword_ContainerDivContents'>
                    <input type="text" onChange={(e) => handlePassword(e,'password')}/>
                    <input type="text" onChange={(e) => handlePassword(e,'confirmPassword')} />
                </div>
                <div>
                    <button onClick={handleChangePassword}>Change</button>
                </div>
                {(countdown > 1 && tokenTimeout === token) ? (
                    <button className='ResendBtn'>Link expires in {countdown}s</button>
                ) : ""}
            </div>
        )}
        
        
    </div>
  )
}

export default CreatePassword
